import { Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ExchangeMsgClient } from '../../api';

import { CerGridComponent, CerGridSelectionInitial, CerGridSelectionMode } from '../../../cer/cer-grid/cer-grid.component';
import { FieldGroupMetadata, FieldMetadata, FieldWidthEnum, ViewMetadata } from '../../../cer/cer-data/cer-data-types';
import { UiCommand, UiCommandEvent } from '@ui/cer-ui-types';
import { CerUiIcons } from '@ui/cer-ui-icons';
import { CerPromptService } from '@ui/cer-ui-prompt.service';
import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';
import { CerFormPaneComponent } from '@form/cer-form-panes/cer-form-pane/cer-form-pane.component';
import { CerFormComponent } from '@form/cer-form.component';
import { ICerFormViewCustomComponent } from '@form/cer-form-view-type/icer-form-view-custom-component';
import { CerFormView } from '@form/cer-form-view';

@Component({
  selector: 'app-forfatter',
  templateUrl: './forfatter.component.html',
  styleUrls: ['./forfatter.component.css']
})

export class ForfatterComponent implements ICerFormViewCustomComponent{
  
  protected panesMain = CerFormPanesSettingsUtil.main();

  // View
  formView: CerFormView;
  public setView(view: CerFormView): void {
    this.formView = view;
  }

  public onViewCommand(e: UiCommandEvent): void {
    this.form?.formService.formCommandNext(e);
  }

  grid: CerGridComponent;
  @ViewChild('grid', { static: false }) set gridContent(content: CerGridComponent) {
    if (content && !this.grid) {
      this.grid = content;
      this.grid.commmand.subscribe(e => this.onCommand(e));
    }
  }

  // Form
  private form: CerFormComponent;
  @ViewChild('form', { static: false }) set formContent(content: CerFormComponent) {
    if (content && this.form != content) {
      this.form = content;
    }
  }

  // Panes
  @ViewChildren(CerFormPaneComponent) set setPaneComponents(paneComponents: QueryList<CerFormPaneComponent>) {
    if (paneComponents?.length > 0 && this.form != null) {
      this.form.initContext(paneComponents);
    }
  }

  public viewMetadata: ViewMetadata = {
    name: 'forfattere', dataApiName: 'Forfatter',
    primaryKey: 'id',
    text: 'Forfattere', textSingular: 'Forfatter', 
    titleFields: ['forfatterId', 'navn'],
    navigations: [{ link: 'nav', title: 'Afregningstabel', foreignKey: { entity: 'afregningstabel', column: 'fid', parentColumn: 'id' }}]
  };

  public fieldGroupMetadata: FieldGroupMetadata[] = [
    { idx: 1, name: 'identification', text: 'Identifikation', fields: ['forfatterId', 'searchName', 'navn', 'attention'] },
    { idx: 2, name: 'address', text: 'Adresse', fields: ['searchAddress', 'adresse1', 'adresse2', 'postNr', 'land'] },
    { idx: 3, name: 'communication', text: 'Kommunikation', fields: ['telefonNr', 'email'] },
    { idx: 3, name: 'setup', text: 'Opsætning', fields: ['cvrCpr', 'valuta'] },
    { idx: 4, name: 'bank', text: 'Bank', fields: ['bankRegNr', 'bankKonto', 'swift', 'iban'] },
    { idx: 4, name: 'status', text: 'Status', fields: ['moms', 'inAktiv'] }
  ];

  public fieldMetadata: FieldMetadata[] =
    [{ name: 'forfatterId', text: 'Nr.', tooltipText: 'Part Id', allowEdit: false, widthType: FieldWidthEnum.XS, visibleEdit: false, visibleAdd: false, orderBy: 'Descending' },
    { name: 'searchName', text: 'Søg navn (virksomhed)', tooltipText: 'Søg virksomhedsnavn', widthType: FieldWidthEnum.L, visible: false, visibleEdit: false, visibleAdd: false },
    { name: 'navn', text: 'Navn', tooltipText: 'Navn på part', widthType: FieldWidthEnum.L, required: true, visibleEdit: true, visibleAdd: true },
    { name: 'attention', text: 'Attention', widthType: FieldWidthEnum.L, visibleEdit: true, visibleAdd: true },
    { name: 'adresse1', text: 'Adresse 1', tooltipText: 'Adresselinje 1', widthType: FieldWidthEnum.L, visibleEdit: true, visibleAdd: true },
    { name: 'adresse2', text: 'Adresse 2', tooltipText: 'Adresselinje 2', widthType: FieldWidthEnum.M, visible: false, visibleEdit: true, visibleAdd: true },
    { name: 'postNr', text: 'Postnr/by', tooltipText: 'Postnr. og by', widthType: FieldWidthEnum.L, visibleEdit: true, visibleAdd: true },
    { name: 'land', text: 'Land', tooltipText: 'Land', widthType: FieldWidthEnum.M, visibleEdit: true, visibleAdd: true },
    { name: 'telefonNr', text: 'Telefon', tooltipText: 'Telefonnr.', widthType: FieldWidthEnum.M, visibleEdit: true, visibleAdd: true, format: 'Phone' },
    { name: 'email', text: 'E-mail', tooltipText: 'E-mail adresse', widthType: FieldWidthEnum.L, visibleEdit: true, visibleAdd: true, format: 'Email' },
    { name: 'bankRegNr', text: 'Bank reg.nr', tooltipText: 'Bank reg.nr', widthType: FieldWidthEnum.L, visible: false, visibleEdit: true, visibleAdd: true },
    { name: 'bankKonto', text: 'Bank konto', tooltipText: 'Bank konto', widthType: FieldWidthEnum.L, visible: false, visibleEdit: true, visibleAdd: true },
    { name: 'swift', text: 'SWIFT', tooltipText: 'SWIFT', widthType: FieldWidthEnum.M, visible: false, visibleEdit: true, visibleAdd: true },
    { name: 'iban', text: 'IBAN', tooltipText: 'IBAN konto', widthType: FieldWidthEnum.M, visible: false, visibleEdit: true, visibleAdd: true },
    { name: 'cvrCpr', text: 'CPR/CVR', tooltipText: 'CPR/CVR nr.', widthType: FieldWidthEnum.M, visible: false, visibleEdit: true, visibleAdd: true },
    { name: 'moms', text: 'Momsregistreret', tooltipText: 'Findes der en momsregistrering', format: 'CheckBox', visible: false, visibleEdit: true, visibleAdd: true },
    { name: 'valuta', text: 'Valuta', tooltipText: 'Valutakode', widthType: FieldWidthEnum.XS, defaultValue: 1, foreignKeyTableName: 'ValutaKoder', foreignKeyField: 'id', foreignKeyValue: 'valutaKode', visibleEdit: true, visibleAdd: true },
    { name: 'inAktiv', text: 'Inaktiv', tooltipText: 'Er denne inaktiv', widthType: FieldWidthEnum.XXS, format: 'CheckBox', filterOperator: 'notequal', filterValue: true, filterOnClient: true, visibleEdit: true, visibleAdd: true },
    { name: 'searchAddress', text: 'Søg dansk adresse', tooltipText: 'Søg dansk adresse', /*format: 'TextArea',*/ visible: false },
    { name: 'source', text: 'Datakilde', tooltipText: 'Hvilken database kommer data fra?', /*format: 'TextArea',*/ visible: false }
    ];

  private exchangeFieldsVisible: string[] = ['cvrCpr', 'bankRegNr', 'bankKonto', 'swift', 'iban'];

  private uiCmdExchangeRelease: UiCommand = { id: 'ExchangeRelease', text: 'Frigiv markerede', iconCss: CerUiIcons.checkMark, tooltipText: 'Frigiv markerede poster til dataudveksling', target: ".e-content", needSelection: true };

  public toolbarCommands: UiCommand[] = [];
  public contextMenuCommands: UiCommand[] = [];

  public addressSearchActive: boolean = false;
  public fromExchange: boolean = false;
  public selectionMode: CerGridSelectionMode = 'row';
  public selectionInitial: CerGridSelectionInitial = 'first';

  constructor(
    private exchangeMsgClient: ExchangeMsgClient,
    private ui: CerPromptService,
    route: ActivatedRoute) {

    const data: any = route?.snapshot?.data;
    if (data != null) {
      this.fromExchange = data['fromExchange'];
      if (this.fromExchange) {
        this.fromExchangeSetup();
      }
    }
  }

  private fromExchangeSetup() {
    this.toolbarCommands.unshift(this.uiCmdExchangeRelease);
    this.selectionMode = 'checkboxMulti';
    this.selectionInitial = 'none';
    this.viewMetadata.dataApiParams = ['$sourceFilter'];
    this.fieldMetadata.forEach(f => { if (this.exchangeFieldsVisible.includes(f.name)) { f.visible = true } });
  }

  // Commands
  private release() {
    var queueIds: number[] = this.grid.selection.rowsSelectedId();
    if (queueIds.length > 0) {
      this.grid.rowSelectedKeep();
      this.exchangeMsgClient.queueRelease(true, queueIds).subscribe({
        next: data => this.grid.research(),
        error: error => this.ui.errorApi(error)
      });
    }
  }

  private onCommand(event: UiCommandEvent) {
    switch (event.commandId) {
      case this.uiCmdExchangeRelease.id:
        this.release();
        break;
    }
  }
}
